<template>
  <div class="popup">
    <Loader v-if="loading" />
    <h4 class="popup__title">Редактирование транзакции</h4>

    <div class="form">
      <div class="form__item">
        <div class="label">
          № АЗС
        </div>
        <div class="input">
          <input type="text" v-model="txEdit.station_number">
        </div>
      </div>

      <div class="form__item">
        <div class="label">
          Оригинальное
          название ВИНКа
        </div>
        <div class="input">
          <input type="text" v-model="txEdit.original_fuel_provider_name">
        </div>
      </div>
      <div class="form__item">
        <div class="label">
          Оригинальное
          название региона
        </div>
        <div class="input">
          <input type="text" v-model="txEdit.original_region_name">
        </div>
      </div>
      <div class="form__item">
        <div class="label">
          Оригинальное
          название типа топлива
        </div>
        <div class="input">
          <input type="text" v-model="txEdit.original_fuel_type_name">
        </div>
      </div>

      <div class="form__item">
        <label class='checkbox-cont'>
          <input v-model="txEdit.partner" class="checkbox" type='checkbox'>
          <span class='indicator'></span>
          <span class="text">Партнер</span>
        </label>
      </div>

    </div>

    <div class="actions">
      <button class="button btn-primary" @click="closeAll()">Отмена</button>
      <button :disabled="disableSubmitButton" class="button btn-primary" @click="confirmEdit()">Сохранить</button>
    </div>
  </div>
</template>

<script>

import {popups} from '@/mixins/popups'
import vSelect from 'vue-select'
import Loader from '@/components/common/Loader.vue'
import 'vue-select/dist/vue-select.css';
import {mapActions, mapMutations, mapState} from "vuex";
import VueDatePicker from "@vuepic/vue-datepicker";
export default {
  name: "editTransactionPopup",
  mixins: [popups],
  components: {
    VueDatePicker,
    vSelect,
    Loader
  },
  data: () => ({
    loading: false,
    spinner: true,
    txEdit: {
      station_number: '',
      original_fuel_provider_name: '',
      original_fuel_type_name: '',
      original_region_name: '',
      partner: false
    }
  }),
  computed: {
    ...mapState({
      transaction: state => state.popups.transaction,
    }),
    disableSubmitButton() {
      return !this.txEdit.original_fuel_provider_name ||
          !this.txEdit.original_fuel_type_name ||
          !this.txEdit.original_region_name
    }
  },
  methods: {
    ...mapActions({
      editTransaction: 'editTransaction',
    }),
    ...mapMutations({
      setColumns: 'SET_COLUMNS',
    }),
    async confirmEdit() {
      this.loading = true

      await this.editTransaction({id: this.transaction.id, data: this.txEdit})

      this.loading = false
      //this.closeAll()
    }
  },
  mounted() {
    if (this.transaction !== null) {
      this.txEdit.station_number = this.transaction.station_number;
      this.txEdit.original_fuel_provider_name = this.transaction.original_fuel_provider_name;
      this.txEdit.original_fuel_type_name = this.transaction.original_fuel_type_name;
      this.txEdit.original_region_name = this.transaction.original_region_name;
      this.txEdit.partner = this.transaction.partner;
    }
  }
}
</script>

<style lang="scss">
.input .v-select .vs__search {
  pointer-events: none;
}
</style>

<style scoped lang="scss">
@import "../../styles/variables";
.popup {
  :deep(.loader) {
    height: 200%;
    width: 200%;
    left: -50%;
    top: -50%;
    border-radius: 25px;
    transform: scale(0.5);
    svg {
      position: unset;
    }
  }
}

.dp__input {
  border-radius: 6px;
  border: 1px solid $back !important;
  --dp-border-color: $back !important;
}

.popup .form__item .label {
  min-width: 120px;
}

.checkbox-cont {
  //padding: 0 10px;
  display: flex;
  width: 100%;
  padding: 10px;
  align-items: center;
  gap: 10px;

  color: #1A1A18;
  font-feature-settings: 'liga' off, 'clig' off;
  //font-family: "SF Pro Text";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
}
</style>
